import { Spinner } from "@blueprintjs/core";
import _ from "lodash";
import React from "react";
import "../css/table.css";

export type TableColumn<T> = {
  label: string;
  render?: (item: T) => React.ReactNode;
  key?: string;
  translate?: { [key: string]: string };
};

export type TableColumns<T> = { [key in keyof T | string]: TableColumn<T> };

interface ITableProps<T> {
  columns: TableColumns<T>;
  items?: T[];
  loading?: boolean;
}

const renderCell = (
  item: any,
  itemIndex: string,
  heading: TableColumn<any>
) => {
  let itemNode;
  if (heading.render) {
    itemNode = heading.render(item);
  } else if (heading.key) {
    itemNode = _.get(item, [itemIndex, heading.key]);
  } else {
    itemNode = _.get(item, [itemIndex]);
  }

  if (heading.translate && !heading.render) {
    itemNode = _.get(heading.translate, itemNode, itemNode);
  }

  return <td key={itemIndex}>{itemNode}</td>;
};

const renderRow = (item: any, index: number, columns: TableColumns<any>) => {
  const cells = _.map(columns, (heading, itemIndex) =>
    renderCell(item, itemIndex, heading)
  );

  return <tr key={index}>{cells}</tr>;
};

export class Table<T> extends React.PureComponent<ITableProps<T>> {
  render() {
    const headers = _.map(this.props.columns, (heading, key) => (
      <th key={key}>{heading.label}</th>
    ));

    let children;
    if (this.props.loading || !this.props.items) children = <></>;
    else
      children = _.map(this.props.items, (item, index) =>
        renderRow(item, index, this.props.columns)
      );

    return (
      <>
        <table
          className="bp4-html-table bp4-html-table-bordered bp4-html-table-striped"
          style={{ width: "100%" }}
        >
          <thead>
            <tr>{headers}</tr>
          </thead>
          <tbody>{children}</tbody>
        </table>
        {this.props.loading ? <Spinner /> : <></>}
      </>
    );
  }
}
